export default __webpack_public_path__ + "static/media/IMG_0470.28e6c119.jpeg";